import Header from "../components/header/header";
import { useLocation } from "react-router";
import { canonicalPath } from "../utils/canonical";

import { Footer } from "../blocks/Footer/Footer";
import { GroupServices } from "../blocks/GroupServices/GroupServices";
import { MenuBottom } from "../blocks/MenuBottom/MenuBottom";
import { MainMorda } from "../blocks/Morda/MainMorda/MainMorda";
import { Services } from "../blocks/sevices/services";
import { WorkPromo } from "../blocks/workpromo/workpromo";
import { ScrollBlock } from "../components/others/ScrollBlock";
import { UserProvider } from "../context/user/UserContext";
import "../core/core.css";
import { DataProvider } from "../hooks/DataContext";
import { SupportProvider } from "../Support/SupportProvider";

const mainPage = () => {
  const currentPage = useLocation();
  return (
    <DataProvider>
      <UserProvider>
        <SupportProvider>
          <div className="body">
            <title>
              {"Сервис управления репутацией от реальных людей — HMREP"}
            </title>
            <link
              rel="canonical"
              href={`https://hmrep.ru${canonicalPath(currentPage.pathname)}`}
            />

            <meta
              name="description"
              content={
                "SERM Публикация пложительных отзывов для компаний или вашего бренда в интернете. HMREP - лучший инструмент для покупки и управления отзывами."
              }
            />

            <ScrollBlock></ScrollBlock>
            <Header></Header>
            <div className="blocks">
              <MainMorda></MainMorda>
              <GroupServices limit={100}></GroupServices>
              <Services></Services>
              <WorkPromo></WorkPromo>
              <Footer></Footer>
            </div>
            <MenuBottom></MenuBottom>
          </div>
        </SupportProvider>
      </UserProvider>
    </DataProvider>
  );
};
export default mainPage;
